import Vue from "vue";
import VueRouter from "vue-router";
import Router from "vue-router";
import Store from "../store";
import commonAppStore from "@common/src/store/modules/app";
import commonRouters from "@common/src/router/index";
import t from "@common/src/i18n/t";

const originalPush = Router.prototype.push;
(Router.prototype as any).push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};
Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "login",
    // component: () => import("@/views/user/login.vue"),
    component: () => {
      if (commonAppStore.state.country === "china") {
        return import("@/views/user/login.vue");
      } else if (commonAppStore.state.country === "my") {
        return import("@/views/user/login-malaysia.vue");
      }
    },
    meta: {
      title: t("v210901.login")
    }
  },
  {
    path: "/test",
    name: "test",
    component: () => import("@/views/other/test.vue"),
    meta: {
      title: "demo"
    }
  },
  {
    path: "/change-pwd",
    name: "changePwd",
    component: () => import("../views/user/change-pwd.vue"),
    meta: {
      title: t("v210901.change-password")
    }
  },
  {
    path: "/legal-notice",
    name: "legalNotice",
    // component: () => import("../views/user/legal-notice.vue"),
    component: () => {
      if (commonAppStore.state.country === "china") {
        return import("../views/user/legal-notice.vue");
      } else if (commonAppStore.state.country === "my") {
        return import("../views/user/legal-notice-malaysia.vue");
      }
    },
    meta: {
      title: t("v210901.legal-notice")
    }
  },
  {
    path: "/privacy-policy",
    name: "privacyPolicy",
    // component: () => import("../views/user/privacy-policy.vue"),
    component: () => {
      if (commonAppStore.state.country === "china") {
        return import("../views/user/privacy-policy.vue");
      } else if (commonAppStore.state.country === "my") {
        return import("../views/user/privacy-policy-malaysia.vue");
      }
    },
    meta: {
      title: t("v210901.Personal-Information-protection-policy")
    }
  },
  {
    path: "/user-agreement",
    name: "userAgreement",
    component: () => import("../views/user/user-agreement.vue"),
    meta: {
      title: t("v210901.User-Service-Agreement")
    }
  },
  {
    path: "/forget-pwd",
    name: "forgetPwd",
    component: () => import("../views/user/forget-pwd.vue"),
    meta: {
      title: t("v210901.retrieve-password")
    }
  },
  {
    path: "/change-success",
    name: "changeSuccess",
    component: () => import("../views/user/change-success.vue"),
    meta: {
      title: t("v210901.modify-successfully")
    }
  },
  {
    path: "/404",
    name: "notFound",
    component: () => import("../views/other/404.vue"),
    meta: {
      title: "404-NotFound"
    }
  },
  {
    // 首页
    path: "/",
    // name: "layout",
    component: () => import("../views/layout/index.vue"),
    children: [
      {
        path: "",
        redirect: "/index"
      },
      {
        path: "index",
        name: "home",
        component: () => {
          if (commonAppStore.state.country === "china") {
            return import("../views/dashboard/index.vue");
          } else if (commonAppStore.state.country === "my") {
            return import("../views/dashboard/index-malaysia.vue");
          }
        },
        meta: {
          title: t("v210901.home-page"),
          menuKey: "workbench"
        }
      },
      {
        path: "notice",
        name: "notice",
        component: () => import("../views/dashboard/notice.vue"),
        meta: {
          title: t("v210901.news"),
          menuKey: "workbench"
        }
      },
      {
        path: "setting/staff",
        name: "staff",
        component: () => import("../views/setting/staff.vue"),
        meta: {
          title: t("v210901.information-employees"),
          menuKey: "setting"
        }
      },
      {
        path: "setting/print-template",
        name: "staff",
        component: () => import("../views/setting/print-template.vue"),
        meta: {
          title: t("v211030.Print-Template"),
          menuKey: "setting"
        }
      },
      {
        path: "setting/staff-add",
        name: "staffAdd",
        component: () => import("../views/setting/staff-edit.vue"),
        meta: {
          title: t("v210901.new-employee"),
          menuKey: "setting",
          menuGroup: ["/setting/staff"]
        }
      },
      {
        path: "setting/staff-edit/:id",
        name: "staffEdit",
        component: () => import("../views/setting/staff-edit.vue"),
        meta: {
          title: t("v210901.Edit-employee-information"),
          menuKey: "setting",
          menuGroup: ["/setting/staff"]
        }
      },
      {
        path: "setting/store",
        name: "store",
        component: () => import("../views/setting/store-info.vue"),
        meta: {
          title: t("v210901.Stores-information"),
          menuKey: "setting"
        }
      },
      {
        path: "setting/permission",
        name: "permission",
        component: () => import("../views/setting/permission.vue"),
        meta: {
          title: t("v210901.Role-Permission-Information"),
          menuKey: "setting"
        }
      },
      {
        path: "setting/permission-add",
        name: "permissionAdd",
        component: () => import("../views/setting/permission-edit.vue"),
        meta: {
          title: t("v210901.Example-permission-information"),
          menuKey: "setting",
          menuGroup: ["/setting/permission"]
        }
      },
      {
        path: "setting/permission-edit/:id",
        name: "permissionEdit",
        component: () => import("../views/setting/permission-edit.vue"),
        meta: {
          title: t("v210901.Example-Modify-role-permission-information"),
          menuKey: "setting",
          menuGroup: ["/setting/permission"]
        }
      },
      {
        path: "setting/permission-view/:id",
        name: "permissionView",
        component: () => import("../views/setting/permission-edit.vue"),
        meta: {
          title: t("v210901.View-role-permission-information"),
          menuKey: "setting",
          menuGroup: ["/setting/permission"]
        }
      },
      {
        path: "setting/supplier",
        name: "supplier",
        component: () => import("../views/setting/supplier.vue"),
        meta: {
          title: t("v210901.supplier"),
          menuKey: "setting"
        }
      },
      {
        path: "setting/supplier-edit/:id",
        name: "supplierEdit",
        component: () => import("../views/setting/supplier-edit.vue"),
        meta: {
          title: t("v210901.Editor-supplier"),
          menuKey: "setting",
          menuGroup: ["/setting/supplier"]
        }
      },
      {
        path: "setting/supplier-add",
        name: "supplierAdd",
        component: () => import("../views/setting/supplier-edit.vue"),
        meta: {
          title: t("v210901.Add-suppliers"),
          menuKey: "setting",
          menuGroup: ["/setting/supplier"]
        }
      },
      {
        path: "setting/warehouse",
        name: "warehouse",
        component: () => import("../views/setting/warehouse.vue"),
        meta: {
          title: t("v210901.Warehouse-information"),
          menuKey: "inventory"
        }
      },
      {
        path: "setting/parts",
        name: "parts",
        component: () => import("../views/setting/parts.vue"),
        meta: {
          title: t("v210901.Spare-parts-information"),
          menuKey: "setting"
        }
      },
      {
        path: "setting/parts-add",
        name: "partsAdd",
        component: () => import("../views/setting/parts-edit.vue"),
        meta: {
          title: t("setting.added-parts"),
          menuKey: "setting"
        }
      },
      {
        path: "setting/parts-edit/:id",
        name: "partsEdit",
        component: () => import("../views/setting/parts-edit.vue"),
        meta: {
          title: t("v210901.Edit-spare-parts"),
          menuKey: "setting"
        }
      },
      {
        path: "setting/parts-category",
        name: "partsClass",
        component: () => import("../views/setting/parts-category.vue"),
        meta: {
          title: t("v210901.Parts-classification"),
          menuKey: "setting"
        }
      },
      {
        path: "setting/customer",
        name: "customer",
        component: () => import("../views/setting/customer.vue"),
        meta: {
          title: t("v210901.customer-information"),
          menuKey: "customer"
        }
      },
      {
        path: "setting/customer-add",
        name: "customerAdd",
        component: () => import("../views/setting/customer-edit.vue"),
        meta: {
          title: t("v210901.Adding-Customer-Information"),
          menuKey: "customer"
        }
      },
      {
        path: "setting/customer-edit/:id",
        name: "customerEdit",
        component: () => import("../views/setting/customer-edit.vue"),
        meta: {
          title: t("v210901.Edit-customer-information"),
          menuKey: "customer"
        }
      },
      {
        path: "setting/customer-view/:id",
        name: "customerView",
        component: () => import("../views/setting/customer-view.vue"),
        meta: {
          title: t("v210901.Viewing-Customer-Information"),
          menuKey: "customer"
        }
      },

      {
        path: "setting/management-mode",
        name: "managementMode",
        component: () => import("../views/setting/management-mode.vue"),
        meta: {
          title: t("v210901.management-mode"),
          menuKey: "setting"
        }
      },
      {
        path: "/service/index",
        name: "serviceIndex",
        component: () => import("../views/service/index.vue"),
        meta: {
          title: t("v210901.service-management"),
          menuKey: "service"
        }
      },
      {
        path: "/service/dashboard",
        name: "serviceWorkshopView",
        component: () => import("../views/service/workshop/workshop-view.vue"),
        meta: {
          title: t("v210901.Kanban-workshop"),
          menuKey: "service"
        }
      },
      {
        path: "/employee/emplyee-push-money/push-money-set",
        name: "employeePushMoneySet",
        component: () => import("../views/employee/emplyee-push-money/push-money-set.vue"),
        meta: {
          title: t("v210901.Commission-set"),
          menuKey: "employee"
        }
      },
      {
        path: "/setting/worker-station",
        name: "employeePushMoneySet",
        component: () => import("../views/setting/worker-station.vue"),
        meta: {
          title: t("v210901.Location-management"),
          menuKey: "setting"
        }
      },
      {
        path: "/service/dispatch-worker/index",
        name: "employeePushMoneySet",
        component: () => import("../views/service/dispatch-worker/dispatch-worker.vue"),
        meta: {
          title: t("v210901.work-order"),
          menuKey: "service"
        }
      },
      {
        path: "/employee/emplyee-push-money/create-project-push-money",
        name: "createProjectPushMoney",
        component: () => import("../views/employee/emplyee-push-money/create-project-push-money.vue"),
        meta: {
          title: t("v210901.Commission-for-new-projects"),
          menuKey: "employee"
        }
      },
      {
        path: "/employee/emplyee-push-money/edit-project-push-money",
        name: "editProjectPushMoney",
        component: () => import("../views/employee/emplyee-push-money/create-project-push-money.vue"),
        meta: {
          title: t("v210901.Edit-project-commissions"),
          menuKey: "employee"
        }
      },
      {
        path: "/employee/emplyee-push-money/push-money-query",
        name: "pushMoneyQuery",
        component: () => import("../views/employee/emplyee-push-money/push-money-query.vue"),
        meta: {
          title: t("v210901.Cut-the-query"),
          menuKey: "employee"
        }
      },
      {
        path: "/employee/emplyee-push-money/push-money-gather",
        name: "pushMoneyGather",
        component: () => import("../views/employee/emplyee-push-money/push-money-gather.vue"),
        meta: {
          title: t("v210901.Commission-summary"),
          menuKey: "employee"
        }
      },
      {
        path: "/employee/employee-wage/wage-accounting",
        name: "wageAccounting",
        component: () => import("../views/employee/employee-wage/wage-accounting.vue"),
        meta: {
          title: t("v210901.wage-accounting"),
          menuKey: "employee"
        }
      },
      {
        path: "/employee/employee-wage/wage-set",
        name: "wageSet",
        component: () => import("../views/employee/employee-wage/wage-set.vue"),
        meta: {
          title: t("v210901.Salary-allocation"),
          menuKey: "employee"
        }
      },
      {
        path: "/employee/emplyee-push-money/push-money-query-detail",
        name: "employeePushMoneyDetail",
        component: () => import("../views/employee/emplyee-push-money/push-money-query-detail.vue"),
        meta: {
          title: t("v210901.Details-of-employee-commission"),
          menuKey: "employee"
        }
      },
      {
        path: "/employee/emplyee-push-money/create-project-push-money/:type",
        name: "createProjectPushMoney",
        component: () => import("../views/employee/emplyee-push-money/create-project-push-money.vue"),
        meta: {
          title: t("v210901.New-parts-commission"),
          menuKey: "employee"
        }
      },
      {
        path: "/study/news",
        name: "news",
        component: () => import("../views/study/news.vue"),
        meta: {
          title: t("v210901.information"),
          menuKey: "study"
        }
      },
      {
        path: "/study/news/:classCode",
        name: "newsItem",
        component: () => import("../views/study/news.vue"),
        meta: {
          title: t("v210901.information"),
          menuKey: "study"
        }
      },
      {
        path: "/study/online-study",
        name: "onlineStudy",
        component: () => import("../views/study/online-study.vue"),
        meta: {
          title: t("v210901.on-line-study"),
          menuKey: "study"
        }
      },
      {
        path: "/study/online-study/:classCode",
        name: "onlineStudyItem",
        component: () => import("../views/study/online-study.vue"),
        meta: {
          title: t("v210901.on-line-study"),
          menuKey: "study"
        }
      },
      {
        path: "/study/interaction-list",
        name: "interactionList",
        component: () => import("../views/study/interaction-list.vue"),
        meta: {
          title: t("v210901.interactive-question-and-answer"),
          menuKey: "study"
        }
      },
      {
        path: "/study/interaction-view/:id",
        name: "interactionView",
        component: () => import("../views/study/interaction-view.vue"),
        meta: {
          title: t("v210901.Post-the-body"),
          menuKey: "study"
        }
      },
      {
        path: "/study/interaction-mine",
        name: "interactionMine",
        component: () => import("../views/study/interaction-mine.vue"),
        meta: {
          title: t("v210901.My-interactive"),
          menuKey: "study"
        }
      },
      {
        path: "/service/add",
        name: "serviceAdd",
        component: () => import("../views/service/service-edit.vue"),
        meta: {
          title: t("v210901.Add-the-service"),
          menuKey: "service"
        }
      },
      {
        path: "/service/retail/add",
        name: "serviceRetailAdd",
        component: () => import("../views/service/retail-order-edit.vue"),
        meta: {
          title: t("v210901.Creating-retail-service"),
          menuKey: "service"
        }
      },
      {
        path: "/service/edit/:id",
        name: "serviceEdit",
        component: () => import("../views/service/service-edit.vue"),
        meta: {
          title: t("v210901.Editing-service"),
          menuKey: "service"
        }
      },
      {
        path: "/service/retail/edit/:id",
        name: "retailServiceEdit",
        component: () => import("../views/service/retail-order-edit.vue"),
        meta: {
          title: t("v210901.Editorial-Retail-services"),
          menuKey: "service"
        }
      },
      {
        path: "/service/view/:id",
        name: "serviceView",
        component: () => import("../views/service/service-view.vue"),
        meta: {
          title: t("v210901.Check-the-service"),
          menuKey: "service"
        }
      },
      {
        path: "/service/arrive/input/:id",
        name: "serviceViewUnArrive",
        component: () => import("../views/service/arrive-store-input.vue"),
        meta: {
          title: t("v210901.To-store-entry"),
          desc: t("v210901.Out-of-store-order"),
          menuKey: "service"
        }
      },
      {
        path: "/service/cashier/:id",
        name: "serviceCashier",
        component: () => import("../views/service/cashier.vue"),
        meta: {
          title: t("v210901.cashier"),
          menuKey: "service"
        }
      },
      {
        path: "/service/settlement-success",
        name: "settlemenSuccess",
        component: () => import("../views/service/settlement-success.vue"),
        meta: {
          title: t("v210901.Payment-success"),
          menuKey: "service"
        }
      },
      {
        path: "/service/settlement-success-credit",
        name: "settlemenSuccessCredit",
        component: () => import("../views/service/settlement-success.vue"),
        meta: {
          title: t("v210901.Payment-success"),
          menuKey: "service"
        }
      },
      {
        path: "/service/make-invoice/:id",
        name: "makeInvoice",
        component: () => import("../views/service/make-invoice.vue"),
        meta: {
          title: t("service.make-out-invoice"),
          menuKey: "service"
        }
      },
      {
        path: "/finance/invoice-manage",
        name: "invoiceManage",
        component: () => import("../views/finance/invoice-manage.vue"),
        meta: {
          title: t("finance.invoice-management"),
          menuKey: "finance"
        }
      },
      {
        path: "/finance/purchase-settlement",
        name: "purchaseSettlementIndex",
        component: () => import("../views/finance/purchase-settlement/index.vue"),
        meta: {
          title: t("finance.procurement-settlement"),
          menuKey: "finance"
        }
      },
      {
        path: "/finance/purchase-settlement-bill/add",
        name: "purchaseSettlementBillAdd",
        component: () => import("../views/finance/purchase-settlement/settlement-bill-edit.vue"),
        meta: {
          title: t("v210901.create-a-new-purchase-settlement-document"),
          menuKey: "finance"
        }
      },
      {
        path: "/finance/purchase-settlement-bill/edit/:id",
        name: "purchaseSettlementBillEdit",
        component: () => import("../views/finance/purchase-settlement/settlement-bill-edit.vue"),
        meta: {
          title: t("v210901.edit-purchase-settlement-document"),
          menuKey: "finance"
        }
      },
      {
        path: "/finance/purchase-settlement-bill/view/:id",
        name: "purchaseSettlementBillView",
        component: () => import("../views/finance/purchase-settlement/settlement-bill-view.vue"),
        meta: {
          title: t("v210901.purchase-statement-details"),
          menuKey: "finance"
        }
      },
      {
        path: "/finance/report-gross-profit",
        name: "FinanceReportGrossProfit",
        component: () => import("../views/finance/report-gross-profit.vue"),
        meta: {
          title: t("finance.gross-analysis"),
          menuKey: "statement"
        }
      },
      {
        path: "/finance/report-business-detail",
        name: "ReportBusinessDetail",
        component: () => import("../views/finance/report-business-detail.vue"),
        meta: {
          title: t("finance.income-expense-analysis"),
          menuKey: "statement"
        }
      },
      {
        path: "/finance/report-output-value",
        name: "FinanceOutputProfit",
        component: () => import("../views/finance/report-output-value.vue"),
        meta: {
          title: t("finance.item-output-value-analysis"),
          menuKey: "statement"
        }
      },
      {
        path: "/finance/analysis-of-payment",
        name: "FinanceAnalysisOfPayment",
        component: () => import("../views/finance/analysis-of-payment.vue"),
        meta: {
          title: t("finance.analysis-payment"),
          menuKey: "statement"
        }
      },
      {
        path: "/finance/tmall-bill",
        name: "tmallBill",
        component: () => import("../views/finance/tmall-bill.vue"),
        meta: {
          title: t("finance.tmall-bills"),
          menuKey: "finance"
        }
      },
      {
        path: "/finance/tmall-bill-view/:id",
        name: "tmallBillView",
        component: () => import("../views/finance/tmall-bill-view.vue"),
        meta: {
          title: t("v210901.bill-details-of-tmall"),
          menuKey: "finance"
        }
      },
      {
        path: "/finance/collection-order",
        name: "collectionOrder",
        component: () => import("../views/finance/collection-order.vue"),
        meta: {
          title: t("finance.receipt"),
          menuKey: "finance"
        }
      },
      {
        path: "/finance/collection-order-add",
        name: "collectionOrderAdd",
        component: () => import("../views/finance/collection-order-add.vue"),
        meta: {
          title: t("v210901.create-collection-document"),
          menuKey: "finance"
        }
      },
      {
        path: "/finance/collection-order-view/:id",
        name: "collectionOrderView",
        component: () => import("../views/finance/collection-order-view.vue"),
        meta: {
          title: t("v210831.view-collection-doc"),
          menuKey: "finance"
        }
      },
      {
        path: "/finance/payment-order",
        name: "paymentOrder",
        component: () => import("../views/finance/payment-order.vue"),
        meta: {
          title: t("finance.payment-order"),
          menuKey: "finance"
        }
      },
      {
        path: "/finance/payment-order-add",
        name: "paymentOrderAdd",
        component: () => import("../views/finance/payment-order-add.vue"),
        meta: {
          title: t("v210901.create-payment-document"),
          menuKey: "finance"
        }
      },
      {
        path: "/finance/payment-order-view/:id",
        name: "paymentOrderView",
        component: () => import("../views/finance/payment-order-view.vue"),
        meta: {
          title: t("v210901.view-payment-documents"),
          menuKey: "finance"
        }
      },
      {
        path: "/finance/sales-summary",
        name: "salesSummary",
        component: () => import("../views/finance/sales-summary.vue"),
        meta: {
          title: t("v210831.sales-summary"),
          menuKey: "finance"
        }
      },
      {
        path: "/purchase/index",
        name: "purchaseList",
        component: () => import("../views/purchase/purchase-list.vue"),
        meta: {
          title: t("purchase.purchase-manage"),
          menuKey: "purchase"
        }
      },
      {
        path: "/purchase/purchase-add",
        name: "purchaseAdd",
        component: () => import("../views/purchase/purchase-edit.vue"),
        meta: {
          title: t("purchase.create-purchase-text"),
          menuKey: "purchase"
        }
      },
      {
        path: "/purchase/purchase-edit/:id",
        name: "purchaseEdit",
        component: () => import("../views/purchase/purchase-edit.vue"),
        meta: {
          title: t("purchase.edit-purchase-text"),
          menuKey: "purchase"
        }
      },
      {
        path: "/purchase/purchase-view/:id",
        name: "purchaseView",
        component: () => import("../views/purchase/purchase-view.vue"),
        meta: {
          title: t("v210901.purchase-details"),
          menuKey: "purchase"
        }
      },
      {
        path: "/purchase/refund-index",
        name: "purchaseRefundList",
        component: () => import("../views/purchase/purchase-refund/purchase-list.vue"),
        meta: {
          title: t("v210901.purchase-return"),
          menuKey: "purchase"
        }
      },
      {
        path: "/purchase/purchase-refund-add",
        name: "purchaseRefundAdd",
        component: () => import("../views/purchase/purchase-refund/purchase-edit.vue"),
        meta: {
          title: t("v210901.new-purchase-return"),
          menuKey: "purchase"
        }
      },
      {
        path: "/purchase/purchase-refund-edit/:id",
        name: "purchaseRefundEdit",
        component: () => import("../views/purchase/purchase-refund/purchase-edit.vue"),
        meta: {
          title: t("v210901.edit-purchase-return"),
          menuKey: "purchase"
        }
      },
      {
        path: "/purchase/purchase-refund-view/:id",
        name: "purchaseRefundView",
        component: () => import("../views/purchase/purchase-refund/purchase-view.vue"),
        meta: {
          title: t("v210901.purchase-return-order-details"),
          menuKey: "purchase"
        }
      },
      {
        path: "/marketing/card-template",
        name: "marketingCardTemplate",
        component: () => import("../views/marketing/card-template-list.vue"),
        meta: {
          title: t("marketing.card-template"),
          menuKey: "marketing"
        }
      },
      {
        path: "/marketing/return-rule-set",
        name: "marketingReturnRuleSet",
        component: () => import("../views/marketing/return-rule-set.vue"),
        meta: {
          title: t("v210831.return-visit-rule-set"),
          menuKey: "marketing"
        }
      },
      {
        path: "/marketing/return-appraise",
        name: "marketingReturnAppraise",
        component: () => import("../views/marketing/return-appraise.vue"),
        meta: {
          title: t("v210831.return-visit-evaluation"),
          menuKey: "marketing"
        }
      },
      {
        path: "/marketing/return/:revisitCommentCode",
        name: "marketingReturn",
        component: () => import("../views/marketing/return.vue"),
        meta: {
          title: t("v210831.return-visit-evaluation"),
          menuKey: "marketing"
        }
      },
      {
        path: "/marketing/upkeep-alert-set",
        name: "marketingUpkeepAlertSet",
        component: () => import("../views/marketing/upkeep-alert-set.vue"),
        meta: {
          title: t("v210831.maintenance-reminder-settings"),
          menuKey: "marketing"
        }
      },
      {
        path: "/marketing/upkeep-alert",
        name: "marketingUpkeepAlert",
        component: () => import("../views/marketing/upkeep-alert.vue"),
        meta: {
          title: t("v210831.maintenance-reminder"),
          menuKey: "marketing"
        }
      },
      {
        path: "/marketing/value-card-add",
        name: "ValueCardAdd",
        component: () => import("../views/marketing/value-card-edit.vue"),
        meta: {
          title: t("v210831.new-stored-value-card-template"),
          menuKey: "marketing"
        }
      },
      {
        path: "/marketing/value-card-edit/:id",
        name: "ValueCardEdit",
        component: () => import("../views/marketing/value-card-edit.vue"),
        meta: {
          title: t("v210831.edit-stored-value-card-template"),
          menuKey: "marketing"
        }
      },
      {
        path: "/marketing/value-card-view/:id",
        name: "ValueCardView",
        component: () => import("../views/marketing/value-card-view.vue"),
        meta: {
          title: t("v210901.view-stored-value-card-template"),
          menuKey: "marketing"
        }
      },
      {
        path: "/marketing/card-template-add",
        name: "marketingCardTemplateAdd",
        component: () => import("../views/marketing/card-template-edit.vue"),
        meta: {
          title: t("v210901.new-card-template"),
          menuKey: "marketing"
        }
      },
      {
        path: "/marketing/card-template-edit/:id",
        name: "marketingCardTemplateEdit",
        component: () => import("../views/marketing/card-template-edit.vue"),
        meta: {
          title: t("marketing.edit-card-template"),
          menuKey: "marketing"
        }
      },
      {
        path: "/marketing/card-template-view/:id",
        name: "marketingCardTemplateView",
        component: () => import("../views/marketing/card-template-view.vue"),
        meta: {
          title: t("v210901.card-template-detail"),
          menuKey: "marketing"
        }
      },
      {
        path: "/marketing/card",
        name: "marketingCard",
        component: () => import("../views/marketing/card-list.vue"),
        meta: {
          title: t("marketing.card-manage"),
          menuKey: "marketing"
        }
      },
      {
        path: "/marketing/card-open",
        name: "cardOpen",
        component: () => import("../views/marketing/card-open.vue"),
        meta: {
          title: t("marketing.open-card"),
          menuKey: "marketing"
        }
      },
      {
        path: "/marketing/card-view/:id",
        name: "marketingCardView",
        component: () => import("../views/marketing/card-view.vue"),
        meta: {
          title: t("v210901.card-details"),
          menuKey: "marketing"
        }
      },
      {
        path: "/marketing/mini-program/setting",
        name: "miniProgramSetting",
        component: () => import("../views/marketing/mini-program/setting.vue"),
        meta: {
          title: t("v210901.applet-settings"),
          menuKey: "marketing"
        }
      },
      {
        path: "/marketing/message-recharge",
        name: "messageRecharge",
        component: () => import("../views/marketing/message-recharge.vue"),
        meta: {
          title: t("v210831.sms-recharge"),
          menuKey: "marketing"
        }
      },
      {
        path: "/marketing/recharge-record",
        name: "rechargeRecord",
        component: () => import("../views/marketing/recharge-record.vue"),
        meta: {
          title: t("v210831.recharge-record"),
          menuKey: "marketing"
        }
      },
      {
        path: "/marketing/sent-record",
        name: "sentRecord",
        component: () => import("../views/marketing/sent-record.vue"),
        meta: {
          title: t("v210831.send-record"),
          menuKey: "marketing"
        }
      },
      {
        path: "/setting/pattern-payment",
        name: "settingPatternPayment",
        component: () => import("../views/setting/pattern-payment.vue"),
        meta: {
          title: t("setting.payment-method"),
          menuKey: "setting"
        }
      },
      {
        path: "/finance/on-account-manage",
        name: "onAccountManage",
        component: () => import("../views/finance/on-account-manage.vue"),
        meta: {
          title: t("finance.payment-management"),
          menuKey: "finance"
        }
      },
      {
        path: "/finance/on-account-detail",
        name: "onAccountDetail",
        component: () => import("../views/finance/on-account-detail.vue"),
        meta: {
          title: t("finance.chargeable-details"),
          menuKey: "finance"
        }
      },
      {
        path: "/guidance/index",
        name: "guidanceIndex",
        component: () => import("../views/guidance/index.vue"),
        meta: {
          title: t("v210801.model-matching"),
          menuKey: "guidance"
        }
      },
      {
        path: "/upgrade/index",
        name: "upgradeIndex",
        component: () => import("../views/upgrade/index.vue"),
        meta: {
          title: t("v260.upgrade-renewal"),
          menuKey: "upgrade"
        }
      },
      {
        path: "/inventory/safety-inventory-list",
        name: "safetyInventory",
        component: () => import("../views/inventory/safety-inventory-list.vue"),
        meta: {
          title: t("v270.safety-stock-threshold-setting"),
          menuKey: "inventory"
        }
      },
      {
        path: "/inventory/safety-inventory-add",
        name: "safetyInventoryAdd",
        component: () => import("../views/inventory/safety-inventory-add.vue"),
        meta: {
          title: t("v270.new-spare-parts-inventory-threshold"),
          menuKey: "inventory"
        }
      },
      {
        path: "/inventory/safety-inventory-edit/:list",
        name: "safetyInventoryEdit",
        component: () => import("../views/inventory/safety-inventory-add.vue"),
        meta: {
          title: t("v270.edit-parts-inventory-threshold"),
          menuKey: "inventory"
        }
      },
      {
        path: "/inventory/safety-inventory-set",
        name: "safetyInventorySet",
        component: () => import("../views/inventory/safety-inventory-set.vue"),
        meta: {
          title: t("v270.inventory-alert-settings"),
          menuKey: "inventory"
        }
      },
      {
        path: "/finance/giti/wechat-app-bill",
        name: "WechatAppBill",
        component: () => import("../views/finance/giti/wechat-app-bill.vue"),
        meta: {
          title: t("v210.passenger-applet-bill"),
          menuKey: "finance"
        }
      },
      {
        path: "/finance/giti/wechat-app-bill-view/:id",
        name: "WechatAppBillView",
        component: () => import("../views/finance/giti/wechat-app-bill-view.vue"),
        meta: {
          title: t("v213.details-of-passenger-applet-bill"),
          menuKey: "finance"
        }
      },
      {
        path: "/inventory/shelf/list",
        name: "ShelfList",
        component: () => import("../views/inventory/shelf/shelf-list.vue"),
        meta: {
          title: t("v210.location-information"),
          menuKey: "inventory"
        }
      },
      {
        path: "/inventory/shelf/add",
        name: "ShelfAdd",
        component: () => import("../views/inventory/shelf/shelf-edit.vue"),
        meta: {
          title: t("v213.add-location-information"),
          menuKey: "inventory"
        }
      },
      {
        path: "/inventory/shelf/edit/:id",
        name: "ShelfEdit",
        component: () => import("../views/inventory/shelf/shelf-edit.vue"),
        meta: {
          title: t("v213.edit-location-information"),
          menuKey: "inventory"
        }
      },
      {
        path: "/instruction/view/:id",
        name: "InstructionView",
        component: () => import("../views/study/instruction-view.vue"),
        meta: {
          title: t("v213.tutorial-details"),
          menuKey: ""
        }
      },
      {
        path: "/app/download",
        name: "InstructionView",
        component: () => import("../views/study/instruction-view.vue"),
        meta: {
          title: t("v213.tutorial-details"),
          menuKey: ""
        }
      },
      {
        path: "/setting/document-number-setting",
        name: "InstructionView",
        component: () => import("../views/setting/document-number-setting.vue"),
        meta: {
          title: t("v216_g.document-no-setting"),
          menuKey: "setting"
        }
      },
      {
        path: "/setting/tax-rate",
        name: "TaxRate",
        component: () => import("../views/setting/tax-rate.vue"),
        meta: {
          title: "Tax rate settings",
          menuKey: "setting"
        }
      },
      {
        path: "/inventory/inventory-check/list",
        name: "InventoryCheckList",
        component: () => import("../views/inventory/inventory-check/list.vue"),
        meta: {
          title: t("v216_6.inventory-counting"),
          menuKey: "inventory"
        }
      },
      {
        path: "/inventory/inventory-check/add",
        name: "InventoryCheckAdd",
        component: () => import("../views/inventory/inventory-check/edit.vue"),
        meta: {
          title: t("v216_6.create-a-new-inventory-sheet"),
          menuKey: "inventory"
        }
      },
      {
        path: "/inventory/inventory-check/edit/:id",
        name: "InventoryCheckEdit",
        component: () => import("../views/inventory/inventory-check/edit.vue"),
        meta: {
          title: t("v216_6.edit-inventory-check"),
          menuKey: "inventory"
        }
      },
      {
        path: "/inventory/inventory-check/view/:id",
        name: "InventoryCheckView",
        component: () => import("../views/inventory/inventory-check/view.vue"),
        meta: {
          title: t("v216_6.inventory-check-detail"),
          menuKey: "inventory"
        }
      },
      ...commonRouters
    ]
  },
  { path: "*", redirect: "/404" }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

function checkUrl() {
  // 都通过
  return true;
}

router.beforeEach((to, from, next) => {
  if (checkUrl()) {
    next();
    Store.commit("base/pushInstructionCallback", null, { root: true });
  } else {
    next("/404");
  }
});
router.afterEach(to => {
  Store.dispatch("base/createTrack", to.path, { root: true });
  Store.commit("base/checkPageHasInstruction", { path: to.fullPath }, { root: true });
  document.title = to.meta.title;
});
export default router;
export { router };
